import { SecuredUserManagementClient } from 'Core/Api/UserManagement/SecuredUserManagementClient';
import { ResetPasswordModel, ChangePasswordBindingModel } from 'Core/Api/UserManagement/Api';
import ConfigUtility from 'Core/ConfigUtility';
import TokenUtility from 'Core/TokenUtility';
import React from 'react';
import { string } from 'prop-types';
import Utility from 'Core/Utility';

export interface Props {
  children?: React.ReactNode;
}

export interface State {
  EmailAddress: string;
  CurrentPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}

export default class ResetPassowrdFormHandler extends React.Component<Props, State> {
  // props: any;
  constructor(props: Props) {
    super(props);
  }

  //   //CHANGE PASSWORD
  async ResetPassword(changePasswordBindingModel: ChangePasswordBindingModel) {
    const client = new SecuredUserManagementClient();
    client.showLoading = true;
    client.handleGeneralError = true;

    // const config = await ConfigUtility.get();
    // const authorization = TokenUtility.GetUMAToken();

    return client.userManagement_ChangePassword(changePasswordBindingModel)
      .catch(Utility.formatError);
  }
}
